var map = {
	"./apps.svg": "d6a1",
	"./arrow-left.svg": "766e",
	"./arrow.svg": "285a",
	"./big-arrow.svg": "0726",
	"./cancel.svg": "ca7d",
	"./category.svg": "3a8d",
	"./circleAlert.svg": "4994",
	"./confirm.svg": "f08e5",
	"./control.svg": "6397",
	"./copy.svg": "b00b",
	"./data.svg": "6e26",
	"./diagnostics.svg": "8700",
	"./filter.svg": "7260",
	"./green-save.svg": "cf5b",
	"./hardware.svg": "cb47",
	"./hide.svg": "ebaa",
	"./internet.svg": "f52e",
	"./menu-rotated-selected.svg": "7f9d",
	"./menu-rotated.svg": "3cbd",
	"./menu-selected.svg": "e4ee",
	"./menu.svg": "c634",
	"./message.svg": "bd77",
	"./microphone.svg": "5095",
	"./notify.svg": "2f0d",
	"./people.svg": "cba5",
	"./printers.svg": "11b59",
	"./program.svg": "97c2",
	"./program2.svg": "0d6a",
	"./program3.svg": "bbf5",
	"./programme.svg": "e3e4",
	"./refresh.svg": "26b1",
	"./refresh2.svg": "d219",
	"./refresh3.svg": "91c6",
	"./relations.svg": "c881",
	"./reports.svg": "09c4",
	"./research.svg": "bc35",
	"./save.svg": "5126",
	"./schedule.svg": "c5cc",
	"./screenshot.svg": "6f3a",
	"./search.svg": "1bfd",
	"./security.svg": "0c2b",
	"./settings.svg": "6a87",
	"./show.svg": "a189",
	"./size.svg": "6637",
	"./start.svg": "9f61",
	"./stop.svg": "e3e2",
	"./sysLogs.svg": "c9c5",
	"./tasks.svg": "befe",
	"./time.svg": "05d4",
	"./trash.svg": "5e98",
	"./user.svg": "26fd",
	"./view.svg": "c60c",
	"./watermark.svg": "3c6e",
	"./webcam.svg": "ecfd",
	"./white-arrow.svg": "cc6b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c303";